import { render, staticRenderFns } from "./catlogModal.vue?vue&type=template&id=f2bcd4e4&"
import script from "./catlogModal.vue?vue&type=script&lang=js&"
export * from "./catlogModal.vue?vue&type=script&lang=js&"
import style0 from "./catlogModal.vue?vue&type=style&index=0&id=f2bcd4e4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports